module.exports = __webpack_public_path__ + "static/shop.c50fa78a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/data/screenshots/llanoseco/shop.jpg
// module id = ./src/app/data/screenshots/llanoseco/shop.jpg
// module chunks = 8